import { defineNuxtPlugin } from '#imports'

import { useAuthStore } from '@backmarket/nuxt-module-oauth/useAuthStore'
import { useUserStore } from '@backmarket/nuxt-module-oauth/useUserStore'

import { updateUserContext } from '../utils/tracking/updateUserContext'

/**
 * Fetch user information when the application loads.
 */
export default defineNuxtPlugin((nuxtApp) => {
  // We only want to fetch user information client-side. If we were to fetch
  // them server-side, this would conflict with our caching strategy, and
  // user information (such as their avatar) would be cached for everbody.

  const authStore = useAuthStore()
  const userStore = useUserStore()

  // we use the nuxt app:suspense:resolve hook to launch the userFetch after hydration
  nuxtApp.hook('app:suspense:resolve', async () => {
    if (authStore.fetched === false && process.env.VITEST !== 'true') {
      await userStore.fetchUser()

      void updateUserContext()
    }
  })
})
